import axios from './base';
import { headers } from './base';
import { apiUrlBase } from '../../../configuration';
import { UserSaved } from '../storage';

export async function postTranslate(user: UserSaved, text: string, targetLanguage: string): Promise<string> {
  return axios
    .post(
      `${apiUrlBase}translate`,
      {
        text,
        targetLanguage,
      },
      {
        headers: headers(user.token),
      }
    )
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    });
}
